import React from "react";
import styles from "../TemporaryPinModal.module.scss";

interface ConfirmBeforeSendingProps {
  customerName: string;
  sendEmail: boolean;
  resetsUsed: number;
  maxResets: number;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onBack: () => void;
}

const ConfirmBeforeSending: React.FC<ConfirmBeforeSendingProps> = ({
  customerName,
  sendEmail,
  resetsUsed,
  maxResets,
  isSubmitting,
  onConfirm,
  onCancel,
  onBack,
}) => {
  const deliveryText = sendEmail ? "SMS and Email" : "SMS";

  return (
    <div>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={onBack}
          disabled={isSubmitting}
        >
          <i className="fas fa-arrow-left" style={{ fontSize: 18 }} />
        </button>
      </div>

      <div className={styles.titleSection}>
        <h2 className={styles.title}>Confirm before sending</h2>
        <p className={styles.subtitle}>
          Review what you're about to trigger. This cannot be undone.
        </p>
      </div>

      <div className={styles.summaryCard}>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>User</span>
          <span className={styles.summaryValue}>{customerName}</span>
        </div>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>Delivery</span>
          <span className={styles.summaryValue}>{deliveryText}</span>
        </div>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>Expires</span>
          <span className={styles.summaryValue}>15 minutes</span>
        </div>
        {/* <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>Resets used</span>
          <span className={styles.summaryValue}>
            {resetsUsed} of {maxResets} today
          </span>
        </div> */}
      </div>

      {/* <div className={styles.policyWarning}>
        <i
          className={`fas fa-exclamation-circle ${styles.policyWarningIcon}`}
        />
        <p className={styles.policyWarningText}>
          This uses <strong>1 of the user's {maxResets} daily</strong> reset
          allowances. Sending when not requested by the customer is a policy
          violation.
        </p>
      </div> */}

      <div className={styles.actionButtons}>
        <button
          className={styles.primaryButton}
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <i className="fa fa-spinner fa-spin" /> Sending...
            </>
          ) : (
            "Confirm and Send"
          )}
        </button>
        <button
          className={styles.secondaryButton}
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ConfirmBeforeSending;
